import {Injectable} from '@angular/core';
import {ServiceDto} from '../_services/configuration-services';
import {BackofficePermissionsService} from './backoffice-permissions.service';
import {RolesService} from './roles-service';

/**
 * Holds the service the user is currently viewing.
 * Populated by view-service.component on load, cleared on destroy.
 *
 * Lets cross-cutting code answer "is the current user an exploitant?" without
 * holding a reference to the parent component.
 */
@Injectable({providedIn: 'root'})
export class ServiceContextService {
    private _service: ServiceDto | null = null;

    constructor(private readonly rolesService: RolesService,
                private readonly backofficePermissionsService: BackofficePermissionsService) {
    }

    setCurrentService(service: ServiceDto | null): void {
        this._service = service;
    }

    clear(): void {
        this._service = null;
    }

    isCurrentBackofficeServiceExploitant(): boolean {
        if (this.rolesService.hasRoleSuperAdmin()) {
            return true;
        }
        const currentBackofficeId = this.backofficePermissionsService.getCurrentBackofficeId();
        if (!currentBackofficeId || !this._service?.backoffices) {
            return false;
        }
        return this._service.backoffices.some(b => b.id === currentBackofficeId);
    }
}
